import { inject, Injectable } from '@angular/core';

import { CoBrowsingSharedService } from '@customer-portal/shared/services';

import {
  isDnvUserHasRestrictedRole,
  shouldRestrictDnvUserFeatures,
} from '../helpers/user-role.helper';
import { ProfileStoreService } from '../state/store-services/profile-store.service';
import { SettingsCoBrowsingStoreService } from '../state/store-services/settings-co-browsing-store.service';

@Injectable({
  providedIn: 'root',
})
export class UserRoleService {
  private readonly profileStoreService = inject(ProfileStoreService);
  private readonly coBrowsingSharedService = inject(CoBrowsingSharedService);
  private readonly settingsCoBrowsingStoreService = inject(
    SettingsCoBrowsingStoreService,
  );

  hasRestrictedRole(): boolean {
    const { accessType } = this.profileStoreService.profileInformation();

    return isDnvUserHasRestrictedRole(accessType);
  }

  shouldRestrictFeatures(): boolean {
    const { accessType } = this.profileStoreService.profileInformation();
    const coBrowsingUserEmail =
      this.coBrowsingSharedService.getCoBrowsingUserEmail();

    return shouldRestrictDnvUserFeatures(accessType, coBrowsingUserEmail);
  }

  getSelectedCoBrowsingCompanyId(): string | null {
    return (
      this.settingsCoBrowsingStoreService.selectedCoBrowsingCompany()?.id ??
      null
    );
  }

  getCoBrowsingUserEmail(): string | null {
    return this.coBrowsingSharedService.getCoBrowsingUserEmail();
  }
}
